<template>
  <!-- Content Left Rail -->
  <div class="settings-center-rail">
    <!-- <call-log v-if="settingsNavSelected == 'calls'"></call-log> -->
    <reviews-indicators
      v-if="settingsNavSelected == 'reviews-indicators'"
    ></reviews-indicators>
    <reviews-feedback
      v-if="settingsNavSelected == 'reviews-feedback'"
    ></reviews-feedback>
    <request-review
      v-if="settingsNavSelected == 'request-review'"
      title="Request Review"
    ></request-review>
    <reviews-request
      v-if="settingsNavSelected == 'reviews-request'"
      title="Review Request Page"
    ></reviews-request>
    <review-sources
      v-if="settingsNavSelected == 'review-sources'"
      title="Review Sources"
    ></review-sources>
    <reviews-request-message
      v-if="settingsNavSelected == 'reviews-request-msg'"
      title="Review Request Message"
      subtitle="Personalize the text message you send to your customers to get more reviews"
      :listTypeId="messageTemplateTypeId"
      :listType="messageTemplateType"
      :item="reviewRequestMessageTemplateItem"
      :onSave="reviewRequestOnSave"
    ></reviews-request-message>
  </div>
</template>

<script>
const ReviewsIndicators = () =>
  import(
    /* webpackChunkName: "components-reviews-pages-ReviewsIndicators" */ `./pages/ReviewsIndicators.vue`
  );
const ReviewsFeedback = () =>
  import(
    /* webpackChunkName: "components-reviews-pages-ReviewsFeedback" */ `./pages/ReviewsFeedback.vue`
  );
const RequestReview = () =>
  import(
    /* webpackChunkName: "components-reviews-pages-RequestReview" */ `./pages/RequestReview.vue`
  );
const ReviewsRequest = () =>
  import(
    /* webpackChunkName: "components-reviews-pages-ReviewsRequest" */ `../settings/ReviewSettingsPane.vue`
  );
const ReviewSources = () =>
  import(
    /* webpackChunkName: "components-reviews-pages-ReviewSources" */ `./pages/ReviewSources.vue`
  );
const ReviewsRequestMessage = () =>
  import(
    /* webpackChunkName: "components-reviews-pages-ReviewsMessageSettings" */ `../settings/fields/ListTypeFieldEditor.vue`
  );

export default {
  name: "ReviewsCenterRail",
  components: {
    ReviewsIndicators,
    ReviewsFeedback,
    RequestReview,
    ReviewsRequest,
    ReviewSources,
    ReviewsRequestMessage
  },
  props: {
    msg: String
  },
  data: function() {
    return {
      toggleFilter: 1,
      // For Review Request Message
      // messageTemplateTypeId: null,
      // messageTemplateType: null,
      // reviewRequestMessageTemplateItem: null
    };
  },
  created() {
    // let vueThis = this;
    // const requestReviewMesssageName = "Ask for Review (Text)";
    // // debugger;
    // let listItems = this.$store.getters["entities/listItems/query"]()
    //   .where(item => {
    //     return (
    //       item.listTypeId == vueThis.messageTemplateTypeId &&
    //       item.name == requestReviewMesssageName
    //     );
    //   })
    //   .get();
    // if (listItems && listItems.length > 0) {
    //   console.log("has review msg item");
    //   this.reviewRequestMessageTemplateItem = listItems[0];
    // } else {
    //   console.log("no review msg item");
    //   const baseMessage =
    //     "We strive for excellent service. A quick review helps us to continue to serve our community. {{REQUEST_REVIEW_LINK}}";
    //   let newItem = {
    //     isDirty: true,
    //     listTypeId: this.messageTemplateTypeId,
    //     rank: 0,
    //     name: requestReviewMesssageName,
    //     meta: {
    //       value: baseMessage
    //     }
    //   };
    //   this.reviewRequestMessageTemplateItem = newItem;
    //   vueThis.$store.dispatch("entities/listItems/createListItem", newItem);
    // }
  },
  watch: {},
  computed: {
    settingsNavSelected() {
      return this.$parent.$parent.$parent.settingsNavSelected;
    },
    messageTemplateTypeId() {
      let listType = this.$store.getters["entities/listTypes/query"]()
        .where(type => {
          return type.code == "msg_template";
        })
        .get();
      return listType.length > 0 ? listType[0].id : null;
    },
    messageTemplateType() {
      let listType = this.$store.getters["entities/listTypes/query"]()
        .where("id", this.messageTemplateTypeId)
        .first();
      return listType;
    },
    reviewRequestMessageTemplateItem() {
      const requestReviewMesssageName = "Ask for Review (Message)";
      let vueThis = this;
      let listItems = this.$store.getters["entities/listItems/query"]()
        .where(item => {
          return (
            item.listTypeId == vueThis.messageTemplateTypeId &&
            item.name == requestReviewMesssageName
          );
        })
        .get();
      if (listItems && listItems.length > 0) {
        return listItems[0];
      } else {
        const baseMessage =
          "We strive for excellent service. A quick review helps us to continue to serve our community. {{REQUEST_REVIEW_LINK}}";
        let newItem = {
          isDirty: true,
          listTypeId: this.messageTemplateTypeId,
          rank: 0,
          name: requestReviewMesssageName,
          meta: {
            value: baseMessage
          }
        };
        return newItem;
      }
    }
  },
  methods: {
    navigateTo(settingType) {
      settingType;
    },
    reviewRequestOnSave(item) {
      let vueThis = this;
      vueThis.$store.dispatch("entities/listItems/updateListItem", item);
    }
  }
};
</script>

<style scoped lang="stylus">
div.settings-left-nav, div.settings-left-nav div {
  background-color: rgb(241, 241, 241);
  width: 100%;
}
.settings-left-nav div.v-list {
  padding: 0;
}
.v-list-item__title {
  padding: 1.5rem 2rem 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  text-transform: uppercase;
}
.subtitle-1 {
  font-size: 1rem;
  font-weight: 400;
}
.v-list-item {
  padding: .5rem 2rem;
}
.settings-center-rail {
  width: 100%;
  padding: 0;
}
</style>
